<template lang="pug">
#sign_language
  custom-header(
    :title="signLanguagePage.Area01Title",
    :subTitle="signLanguagePage.Area01Content",
    :Alert1="signLanguagePage.Area01Alert1",
    :Alert2="signLanguagePage.Area01Alert2",
    :DownloadList_URL="signLanguagePage.Area01DownloadList_URL"
    :youtube="signLanguagePage.Area01YoutubeID",
    :icon1="signLanguagePage.Area01Image1",
    :icon2="signLanguagePage.Area01Image2"
  )
  section.container
    h2.i_h2_title.text-center.i_mt_10 {{ signLanguagePage.ApplystepTitle }}
    p.i_content.text-center {{ signLanguagePage.ApplystepSubtitle }}
    .timeline.i_mt_8.d-flex.flex-column.flex-md-row.justify-content-center(
      :class="{ expand: isCollapseExpand }"
    )
      timeline-item.flex-grow-1(
        v-for="(timelineItem, index) in signLanguagePage.Applystep",
        :key="index",
        :title="timelineItem.Title",
        :icon="timelineItem.Img",
        :content="timelineItem.Content"
      )
    .row.text-center.i_mt_6.i_mb_6
      .collapse_btn(
        @click="isCollapseExpand = !isCollapseExpand",
        :class="{ expand: isCollapseExpand }"
      ) {{ isCollapseExpand ? collapseText[1] : collapseText[0] }}
  media-img.golden_line_up(:imgUrl="'golden_line_up'")
  section.container
    p.i_content.text-left.text-tips(v-html="signLanguagePage.Tips")
  section.container-fluid.bg_blue.i_ptb_10
    .container.custom_container_md.form
      h2.i_h2_title.text-center {{ signLanguagePage.BookTitle }}
      p.i_content.text-center.booktip {{ signLanguagePage.BookTip }}
        //- span.d-block.d-md-inline-block 敬請完整填寫以下基本資料與內容
      .row.i_mt_14
        .col-12
          label.form_label 您的姓名
          input.input_text(type="text", placeholder="請輸入您的姓名", v-model="name")
        .col-12.i_mt_8
          label.form_label 手機號碼
          input.input_text(
            type="text",
            placeholder="請輸入您的手機號碼",
            v-model="phone"
          )
          p.i_content.input_text_tip 為確認服務時間請務必留存正確號碼
        .col-12.i_mt_8.border-b
          label.form_label 預約時間
          v-select.input_text(
            :components="{Deselect}",
            class="style-chooser",
            placeholder="請選擇時間",
            :options="timeArray",
            label="Time",
            :reduce="(option) => option",
            v-model="time"
          )
            template(#open-indicator="{ attributes }")
              span(v-bind="attributes")
                .select-icon
        .col-12.i_mt_8
          label.form_label 地區別
          v-select.input_text(
            :components="{Deselect}",
            class="style-chooser",
            placeholder="請選擇地區",
            :options="signLanguagePage.BookAreaList",
            label="AreaName",
            :reduce="(option) => option.AreaID",
            v-model="area",
            @input="getBookInsuranceCategoryList"
          )
            template(#open-indicator="{ attributes }")
              span(v-bind="attributes")
                .select-icon
        .col-12.i_mt_8
          label.form_label 詢問類別
          v-select.input_text(
            :components="{Deselect}",
            class="style-chooser",
            placeholder="請選擇詢問類別",
            :options="BookInsuranceCategoryList",
            label="Name",
            :reduce="(option) => option.Id",
            v-model="insurancecategory",
            @input="getBookInsuranceTypeList",
            :disabled="area === '' ? true : false"
          )
            template(#open-indicator="{ attributes }")
              span(v-bind="attributes")
                .select-icon
        .col-12.i_mt_8
          label.form_label 詢問商品
          v-select.input_text(
            :components="{Deselect}",
            class="style-chooser",
            placeholder="請選擇詢問商品",
            :options="BookInsuranceTypeList",
            label="Name",
            :reduce="(option) => option.Id",
            v-model="insurancetype",
            @input="getlocationList",
            :disabled="insurancecategory === '' ? true : false"
          )
            template(#open-indicator="{ attributes }")
                span(v-bind="attributes")
                  .select-icon
        .col-12.i_mt_8.flex_h.align-items-start
          label.form_label.selector 服務地點
          .container
            map-item(
              v-if="area !== '' && insurancecategory !== '' && insurancetype !== ''",
              v-for="(locationItem) in locationList",
              :key="locationItem.Id",
              :LocationName="locationItem.Name",
              :LocationAddr="locationItem.Addr",
              :LocationTel="locationItem.Tel",
              :LocationFax="locationItem.Fax",
              :LocationImage="locationItem.Image",
              @click.native="location = locationItem.Id",
              :class="{ selected: location == locationItem.Id }",
              v-model="location"
            )
            .row.map-item-none(
              v-if="area === '' || insurancecategory === '' || insurancetype === ''"
            ) 請先選擇地區別、類別及商品
        p.i_content.input_text_tip_2 請點選服務地點
        .col-12.i_mt_8.flex_h.align-items-start
          label.form_label 詢問內容
          textarea.input_text(type="text", v-model="opinionContent")
  section.container-fluid.i_ptb_10
    .container.custom_container_md.form
      .row
        .col-12.col-md-auto.verify
          label.form_label 輸入驗證碼
          input.input_text(type="text", v-model="identifyCode")
        .col-12.col-md-auto.verify.d-flex.align-items-center.i_mt_sm_4
          .refresh_code_btn.d-flex.align-items-center.justify-content-center.justify-content-sm-end
            img.verify_code(:src="identifyCodeUrl")
            img.i_ml_4(@click="refreshCode")
            span.i_ml_1(@click="refreshCode") 重新產生驗證碼
    .container.custom_container_md
      .row
        .terms_wrapper.i_mlr_auto
          .terms.i_mt_11.i_plr_6.i_ptb_6
            pre.i_body(v-html="signLanguagePage.Rule")
          .details.d-flex.justify-content-between.i_mt_4
            .check.d-flex
              input(type="checkbox", v-model="checkBtnStatus")
              span.i_body.i_ml_2 我已閱讀並同意《新安東京海上產險履行個人資料保護法告知義務內容》
            //- a.download_btn.d-flex.align-items-center.flex-shrink-0(
            //-   :href="contactUsPage.area02_PersonInformation_FileURL",
            //-   target="_blank"
            //- )
            //-   svg-icon(iconClass="ic_download", className="icon")
            //-   span 下載
      .row.justify-content-center.i_mt_10
        //- .btn_round.btn_border_blue_ci(@click="resetData") 清除表單
        .btn_round.btn_yellow(@click="confirm") 確認預約
  dedicated-line

</template>

<script>
import CustomHeader from "@/components/customer_service/Header";
import { getSignLanguagePage } from "@/json/customer_service";
import { sendSignLanguage } from "@/api/signlanguage";
import TimelineItem from "@/components/customer_service/TimelineItem";
import MediaImg from "@/components/common/MediaImg";
import MapItem from "@/components/customer_service/location";
import DedicatedLine from "@/components/customer_service/DedicatedLine";
import vSelect from "vue-select";

export default {
  name: "CustomerServicesignLanguagePage",
  metaInfo() {
    return {
      title: this.signLanguagePage.SEOTitle,
      meta: [
        { name: "description", content: this.signLanguagePage.SEODescription },
      ],
    };
  },
  components: {
    "custom-header": CustomHeader,
    "timeline-item": TimelineItem,
    "media-img": MediaImg,
    "map-item": MapItem,
    "dedicated-line": DedicatedLine,
    "v-select": vSelect,
  },
  data() {
    return {
      // contactUsPage: {},
      signLanguagePage: {},
      // CompanyList: {},
      productCategory: [],
      name: "",
      phone: "",
      time: "",
      timeArray: [],
      disabled: false,
      area: "",
      BookInsuranceCategoryList: [],
      insurancecategory: "",
      BookInsuranceTypeList: [],
      insurancetype: "",
      locationList: [],
      location: "",
      opinionContent: "",
      identifyCode: "",
      identifyCodeUrl:
      process.env.BASE_URL + "api/contactus/captcha?mode=0&" + new Date().getTime(),
      checkBtnStatus: false,
      isCollapseExpand: true,
      collapseText: ["收起細部步驟", "觀看細部步驟"],
      attributes: {
        'ref': 'openIndicator',
        'role': 'presentation',
        'class': 'vs__open-indicator',
      },
      Deselect: {
        render: createElement => createElement('span', ''),
      },
    };
  },
  created() {
    this.getSignLanguagePage();
    // this.getCompanyList();
    this.getDateArray();
  },
  methods: {
    getSignLanguagePage() {
      getSignLanguagePage().then((response) => {
        this.signLanguagePage = response.data;
      });
    },
    getBookInsuranceCategoryList() {
      const Areath = Object.values(this.signLanguagePage.BookAreaList).map(item => item.AreaID).indexOf(this.area);
      this.BookInsuranceCategoryList = this.signLanguagePage.BookAreaList[Areath].BookInsuranceCategoryList;
      this.BookInsuranceTypeList = [];
      this.insurancetype = "";
      this.insurancecategory = "";
      this.locationList = [];
      this.location = "";
    },
    getBookInsuranceTypeList() {
      const InsuranceCategoryth = Object.values(this.BookInsuranceCategoryList).map(item => item.Id).indexOf(this.insurancecategory);
      this.BookInsuranceTypeList = this.BookInsuranceCategoryList[InsuranceCategoryth].BookInsuranceTypeList;
      this.locationList = [];
      this.location = "";
      this.insurancetype = "";
    },
    getlocationList() {
      const InsuranceTypeth = Object.values(this.BookInsuranceTypeList).map(item => item.Id).indexOf(this.insurancetype);
      this.locationList = this.BookInsuranceTypeList[InsuranceTypeth].LocationList;
    },
    getDateArray() {
      getSignLanguagePage().then((response) => {
        let addDate
        switch (new Date().getDay()) {
          case 1:
            addDate = 7
            break;
          case 2:
            addDate = 6
            break;
          case 3:
            addDate = 5
            break;
          case 4:
            addDate = 4
            break;
          case 5:
            addDate = 10
            break;
          case 6:
            addDate = 9
            break;
          case 0: 
            addDate = 8
            break;
        }
        const  startTime =  new Date(new Date().setDate(new Date().getDate()+addDate));
        const  endTime = new Date(new Date().setDate(new Date().getDate()+60));
        const  weekDay = response.data.BookTime;
        const NationalHoliday = response.data.NationalHoliday;
        let newHoliday =[]
        let datelen = []
        for(let  h = 0;h < NationalHoliday.length; h++) {
            newHoliday.push(new Date(NationalHoliday[h]).getTime());
        }
        while ((endTime.getTime()-startTime.getTime())>=0){
            const  year = startTime.getFullYear();
            const  month = (startTime.getMonth()+1).toString().length==1? "0" +(startTime.getMonth() + 1).toString():startTime.getMonth() + 1;
            const  day = startTime.getDate().toString().length==1? "0" +startTime.getDate():startTime.getDate();
            const  date = year+ "-" +month+ "-" +day;
            for ( let  i = 0;i < weekDay.length; i++) {
                if (new Date(date).getDay() == weekDay[i].Week) {  
                    if(newHoliday.indexOf(new Date(new Date(date).getFullYear()+"/"+(new Date(date).getMonth()+1)+"/"+new Date(date).getDate()).getTime()) == -1) {
                        datelen.push(new Date(date).getFullYear()+"/"+(new Date(date).getMonth()+1)+"/"+new Date(date).getDate());
                        for( let d = 0;d < weekDay[i].Time.length; d++){
                            if(datelen.length < 8) {
                                this.timeArray.push(date +" "+ weekDay[i].Time[d]);
                            }
                        }
                    }
                }
            }
            startTime.setDate(startTime.getDate()+1);
        }
      });
    },
    // getCompanyList() {
    //   getCompanyList().then((response) => {
    //     this.CompanyList = response.data;
    //   });
    // },
    refreshCode() {
      this.identifyCodeUrl =
        process.env.BASE_URL + "api/contactus/captcha?mode=0&"  + new Date().getTime();
    },
    checkData() {
      if (
        this.name == "" ||
        this.phone == "" ||
        this.time == "" ||
        this.area == "" ||
        this.insurancecategory == "" ||
        this.insurancetype == "" ||
        this.location == "" ||
        this.opinionContent == "" ||
        this.identifyCode == "" ||
        this.checkBtnStatus == false
      ) {
        // console.log(this.name,this.phone,this.time,this.area,this.insurancecategory,this.insurancetype,this.opinionContent,this.identifyCode,this.checkBtnStatus)
        alert(
          "請填寫所有資料並且閱讀並同意《新安東京海上產險履行個人資料保護法告知義務內容》"
        );
        return false;
      }
      return true;
    },
    resetData() {
      this.name = "";
      this.phone = "";
      this.time = "";
      this.area = "";
      this.insurancetype = "";
      this.insurancecategory = "";
      this.location = "";
      this.opinionContent = "";
      this.identifyCode = "";
      this.checkBtnStatus = false;
      this.refreshCode();
    },
    confirm() {
      if (!this.checkData()) {
        return;
      }
      let data = {
        datatype: "datatype",
        Captcha: this.identifyCode,
        Name: this.name,
        Phone: this.phone,
        Time: this.time,
        Area: this.area,
        Insurancetype: this.insurancetype,
        Insurancecategory: this.insurancecategory,
        Location: this.location,
        Content: this.opinionContent,
      };
      sendSignLanguage(data)
        .then((response) => {
          if (response.data.Status) {
            this.resetData();
            alert(
              "感謝您的留言! 新安東京海上產險已收到您的預約來信."
            );
          } else {
            alert(response.data.Message);
          }
        })
        .catch(() => {
          alert("伺服器錯誤，請洽管理人員");
          // console.log(data)
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/timeline_stepline";
@import "@/assets/style/customer_service/sign_language";
</style>
<style lang="scss">
.i_content{
    width: 100%;
}
iframe{
    height: 90%;
    @media (max-width: 767px) {
        width: 41vw;
        height: 31vw;
    }
}
#sign_language .btn_wrapper{
  display: none
}
@import 'vue-select/src/scss/vue-select.scss';
.style-chooser{
    display: inline-block;
    color: #4f4f4f;
}
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle{
  border: none;
}
.style-chooser .vs__search{
  opacity: .7;
}
.style-chooser .vs__dropdown-menu{
  border: 1px solid #dbdbdb;
  max-height: 200px;
  overflow-y: auto;
  z-index: 3;
}
.vs__selected{
  margin: 0 2px;
}
.style-chooser .vs__dropdown-toggle{
  padding: 0;
}
.style-chooser .vs__dropdown-option:hover, 
.style-chooser .vs__dropdown-option--deselect,
.style-chooser .vs__dropdown-option--selected,
.style-chooser .vs__dropdown-option--highlight,
.style-chooser .vs__dropdown-option--disabled{
  background: #f3f9fc;
  color: #4f4f4f;
  padding-left: 5%;
}
.style-chooser .vs__dropdown-option{
  padding: 13px 13px 13px 5%;
}
.style-chooser  .vs__search, .vs__search:focus{
  margin: 0;
  padding-left: 0;
  color: #4f4f4f;
}
.terms_wrapper .terms{
  height: 268px !important;
}
.timeline_item img{
  width: 80px;
  height: 80px;
}
@media (max-width: 991px){
  .timeline_item img{
    width: 50px;
    height: 50px;
  }
}
@media (max-width: 767px){
  .timeline_item img{
    width: 75px;
    height: 75px;
  }
}
@media (max-width: 575px){
  .timeline_item img{
    width: 13.2vw;
    height: 13.2vw;
  }
}
.header_container h1{
  font-weight: 500 !important;
}
.alert1{
  margin-bottom: 0;
}
.alert2{
  margin-top: 0 !important;
  margin-bottom: 0;
}
.alert1 i,.alert2 i{
  margin-right: .3rem;
}
.vs--disabled{
  cursor: not-allowed;
  background-color: #f8f8f8;
}
</style>
